import { PageListDataSource, ArrayDataSource } from './BaseDataSources';
import { IPackageVersion, IPackageHistory, IPackageVersionMilestone } from '../Interfaces';
import { IPackageMilestones } from '../../Pages/TransactionManagement/Edit/Interfaces';


export class PackageVersionSource extends PageListDataSource<IPackageVersion> {
  public constructor(packageId: string) {
    super('/datasource/packageversions', { packageId });
  }
}


export class PackageHistorySource extends PageListDataSource<IPackageHistory> {
  public constructor(packageId: string) {
    super('/datasource/packagehistory', { packageId });
  }
}


export class PackageMilestoneSource extends PageListDataSource<IPackageMilestones> {
  public constructor(packageId: string) {
    super('/datasource/packagemilestones', { packageId });
  }
}

export class PackageVersionMilestoneSource extends ArrayDataSource<IPackageVersionMilestone> {
  public constructor(packageId: string) {
    super('/datasource/packageversionmilestones', { packageId });
  }
}

